'use client';

import { useAppSelector } from '@/lib/redux/hooks';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { IoCartOutline } from 'react-icons/io5';

import { FaRegHeart } from 'react-icons/fa6';

export const CartIcon = () => {
  return (
    <>
      <svg
        className="svg-inline--fa fa-cart-shopping"
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="cart-shopping"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        data-fa-i2svg=""
      >
        <path
          fill="currentColor"
          d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        ></path>
      </svg>
    </>
  );
};

const HeaderCart = () => {
  const cart = useAppSelector((state) => state.cart.items || []);
  const wishlist = useAppSelector((state) => state.wishlist.items || []);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
    setTotalQuantity(cart.reduce((total, item) => total + item.quantity, 0));
  }, [cart]);

  if (!mounted) return null; // Prevents SSR mismatch

  return (
    <>
      <Link
        className="header__action-btn d-none d-xl-grid cart-link"
        href="/wishlist"
        aria-label="wishlist"
      >
        <FaRegHeart />
        {wishlist.length > 0 && (
          <span className="cart-count">{wishlist.length}</span>
        )}
      </Link>

      <Link
        className="header__action-btn d-none d-xl-grid cart-link"
        href="/cart"
        aria-label="cart"
      >
        <IoCartOutline />
        {totalQuantity > 0 && (
          <span className="cart-count">{totalQuantity}</span>
        )}
      </Link>
      {/* For mobile menu */}
      <Link
        href="/cart"
        className="header__action-btn menu-icon d-xl-none cart-link"
      >
        <IoCartOutline />
        {totalQuantity > 0 && (
          <span className="cart-count">{totalQuantity}</span>
        )}
      </Link>
    </>
  );
};

export default HeaderCart;
